import { useEffect, useRef, useState } from "react";

export const useDetectOverflow = () => {
    const ref = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (ref.current) {
                const hasOverflow = ref.current.scrollWidth > ref.current.clientWidth;
                setIsOverflowing(hasOverflow);
            }
        };

        handleResize(); // Check initially
        window.addEventListener("resize", handleResize); // Update on resize
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return [ref, isOverflowing];
};
